import { encode, decode } from 'base62/lib/ascii';
import { CURIOSO_NAMES } from '../data/constants';

const questionsData = require('../content/questionsData.json');
const curiosoDescriptions = require('../content/curiosoDescriptions.json');

export const generateIdForCurioso = (state) => {
  const { selectedAnswers } = state;

  let moosebearTotal = 0;
  let catlizardTotal = 0;
  let birdrabbitTotal = 0;
  let finalCuriosoName = '';
  let augList = '';

  Object.keys(selectedAnswers).forEach(questionId => {
    const answerId = selectedAnswers[questionId];
    const questionObject = questionsData.questions.find(e => e.questionId === questionId);
    const answerObject = questionObject.answerChoices.find(e => e.answerId === answerId);

    augList += `${answerId}`;
    if (answerObject) {
      moosebearTotal += answerObject.moosebearValue;
      catlizardTotal += answerObject.catlizardValue;
      birdrabbitTotal += answerObject.birdrabbitValue;
    } else {
      console.warn(`no answer found for ${questionId}`);
    }
  });

  if (moosebearTotal > catlizardTotal && moosebearTotal > birdrabbitTotal) {
    finalCuriosoName = CURIOSO_NAMES.MOOSEBEAR;
  } else if (catlizardTotal > moosebearTotal && catlizardTotal > birdrabbitTotal) {
    finalCuriosoName = CURIOSO_NAMES.CATLIZARD;
  } else {
    finalCuriosoName = CURIOSO_NAMES.BIRDRABBIT;
  }

  return `${finalCuriosoName+1}${augList}` // +1 is needed to prevent bugs if finalCuriosoName is 0.
}

export const encodeCurioso = (decodedCuriosoString) => {
  return encode(decodedCuriosoString);
}

export const decodeCurioso = (encodedCuriosoString) => {
  return decode(encodedCuriosoString);
}

export const parseDecodedCurioso = (decodedCuriosoString) => {
  const data = `${decodedCuriosoString}` // stringify the data in case it came in as a number.
  const augmentations = [];
  const descriptionStrings = [];

  let curiosoName = '';
  const curiosoNumber = parseInt(data[0], 10) - 1; // 1-indexed to prevent a leadin 0 from being removed during string encoding.

  if (curiosoNumber === CURIOSO_NAMES.MOOSEBEAR) {
    curiosoName = 'Moosebear';
  } else if (curiosoNumber === CURIOSO_NAMES.CATLIZARD) {
    curiosoName = 'Catlizard';
  } else if (curiosoNumber === CURIOSO_NAMES.BIRDRABBIT) {
    curiosoName = 'Birdrabbit';
  }

  descriptionStrings.push(curiosoDescriptions[curiosoNumber]);

  for(let i = 1; i < data.length; i++) {
    const augmentationCategory = i - 1;
    const augmentationIndex = parseInt(data[i], 10) - 1;
    if (augmentationIndex !== -1) {
      augmentations.push(questionsData.augmentationNames[augmentationCategory][augmentationIndex]);
    }

    const additionalDescription = questionsData.finalMessages[augmentationCategory][augmentationIndex];
    if (additionalDescription !== null) {
      descriptionStrings.push(additionalDescription);
    }
  }

  return {
    curiosoName,
    augmentations,
    curiosoNumber,
    descriptionStrings,
  }

}

// I guess these are technically selectors and not utility functions. *shrug*
export const getDefaultCheckedIndex = (state, ownProps) => {
  const keys = Object.keys(state.selectedAnswers);
  const questionIndex = parseInt(ownProps.match.params.questionIndex, 10);
  const myKey = keys[questionIndex];

  return state.selectedAnswers[myKey] - 1;
}

export const getIsNextButtonDisabled = (state, ownProps) => {
  const keys = Object.keys(state.selectedAnswers);
  const questionIndex = parseInt(ownProps.match.params.questionIndex, 10);
  const myKey = keys[questionIndex];

  return state.selectedAnswers[myKey] === 0;
}